import { UiKit as UiKitNPM, UiKitIconType as UiKitIconTypeNPM } from '@datavant/uikit';
export const UiKit = UiKitNPM;
export type UiKitIconType = UiKitIconTypeNPM;
